import PropTypes from 'prop-types'

import { getAssetLink } from '../../../helpers/get-asset-link'

const AmenityBox = ({ amenity, onClick, selectedAmenity }) => {
  return (
    <div
      className="amenity-box"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0,
          ${selectedAmenity && selectedAmenity.id === amenity.id ? '0.2' : '0.6'}),
          rgba(0, 0, 0, ${selectedAmenity && selectedAmenity.id === amenity.id ? '0.2' : '0.6'})),
          url(${getAssetLink({ path: 'chitown-building', file: amenity.image })})`,
      }}
      onClick={() => onClick(amenity)}
    >
      {amenity.name}
    </div>
  )
}

AmenityBox.propTypes = {
  amenity: PropTypes.object,
  onClick: PropTypes.func,
  selectedAmenity: PropTypes.object,
}

export default AmenityBox
